import { t } from 'i18next';
import React from 'react';
import { Tooltip } from 'primereact/tooltip';

/**
 * Canonical map of model icon classes (`ico--gpt-bck` etc.) to their i18n label keys.
 * Single source of truth — any component that needs to render a model name from an icon
 * class should import this map rather than duplicating the entries.
 */
export const MODEL_ICON_TO_I18N_KEY: Map<string, string> = new Map([
  ['ico--gpt-bck', 'gptName'],
  ['ico--gemini-bck', 'geminiName'],
  ['ico--claude-bck', 'claudeName'],
  ['ico--copilot-bck', 'copilotSearchName'],
  ['ico--grok-bck', 'grokSearchName'],
  ['ico--deepseek-bck', 'deepSeekName'],
  ['ico--perplexity-bck', 'perplexityName'],
  ['ico--ai-overview-bck', 'aiOverviewName'],
  ['ico--ai-mode', 'aiModeName'],
]);

const ModelTooltips = () => {
  return (
    <>
      {Array.from(MODEL_ICON_TO_I18N_KEY.entries()).map(([key, value]) => (
        <Tooltip
          key={key}
          target={`.${key}`}
          className="tooltip--primary tooltip--top"
          position="top"
          showDelay={5}
        >
          {t(value)}
        </Tooltip>
      ))}
    </>
  );
};

export default ModelTooltips;
